import React from "react";

export default function ArrowDown({ deg }) {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${deg}deg)`, transition: "all .3s" }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.85225 7.10421C2.07192 6.88454 2.42808 6.88454 2.64775 7.10421L9 13.4565L15.3523 7.10421C15.5719 6.88454 15.9281 6.88454 16.1477 7.10421C16.3674 7.32388 16.3674 7.68003 16.1477 7.8997L9.39775 14.6497C9.17808 14.8694 8.82192 14.8694 8.60225 14.6497L1.85225 7.8997C1.63258 7.68003 1.63258 7.32388 1.85225 7.10421Z"
        fill="#9B27AF"
      />
    </svg>
  );
}
